import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const adminGuard: CanActivateFn = (
  route,
  state
): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.currentUser$.pipe(
    take(1),
    map((user) => {
      if (!authService.isLoggedIn()) {
        router.navigate(['/login'], {
          queryParams: { returnUrl: state.url, adminRequired: 'true' },
          replaceUrl: true,
        });
        return false;
      }

      if (!user?.is_admin) {
        router.navigate(['/home'], {
          queryParams: { error: 'admin-access-required' },
          replaceUrl: true,
        });
        return false;
      }

      return true;
    })
  );
};
